import React from "react";
import Button from "./Button";
import Default from "./Default";
import Delete from "./Delete";

export default function ButtonParent(props){
    const styling = {
        backgroundColor: props.buttonParentBackgroundcolor,
        borderRadius: "10px",
        display: "grid",
        gridTemplateColumns: "repeat(4, 1fr)",
        gridTemplateRows: "repeat(5, 1fr)",
        padding:"20px",
        gridGap: "10px"
    }
    
    return (
        <div id = "keypadParent" style = {styling}>
            <Button name = "7" onClick = {props.getNumber} shadow = {props.numbersShadowColor} color = {props.numbersColor} background = {props.numbersBackgroundColor}/>
            <Button name = "8" onClick = {props.getNumber} shadow = {props.numbersShadowColor} color = {props.numbersColor} background = {props.numbersBackgroundColor}/>
            <Button name = "9" onClick = {props.getNumber} shadow = {props.numbersShadowColor} color = {props.numbersColor} background = {props.numbersBackgroundColor}/>
            <Delete 
                clicked = {props.delete} 
                backgroundColor = {props.deleteBackgroundColor}
                shadowColor = {props.deleteShadowColor}
            />
            <Button name = "4" onClick = {props.getNumber} shadow = {props.numbersShadowColor} color = {props.numbersColor} background = {props.numbersBackgroundColor}/>
            <Button name = "5" onClick = {props.getNumber} shadow = {props.numbersShadowColor} color = {props.numbersColor} background = {props.numbersBackgroundColor}/>
            <Button name = "6" onClick = {props.getNumber} shadow = {props.numbersShadowColor} color = {props.numbersColor} background = {props.numbersBackgroundColor}/>
            <Button name = "+" onClick = {props.getNumber} shadow = {props.numbersShadowColor} color = {props.numbersColor} background = {props.numbersBackgroundColor}/>
            <Button name = "1" onClick = {props.getNumber} shadow = {props.numbersShadowColor} color = {props.numbersColor} background = {props.numbersBackgroundColor}/>
            <Button name = "2" onClick = {props.getNumber} shadow = {props.numbersShadowColor} color = {props.numbersColor} background = {props.numbersBackgroundColor}/>
            <Button name = "3" onClick = {props.getNumber} shadow = {props.numbersShadowColor} color = {props.numbersColor} background = {props.numbersBackgroundColor}/>
            <Button name = "-" onClick = {props.getNumber} shadow = {props.numbersShadowColor} color = {props.numbersColor} background = {props.numbersBackgroundColor}/>
            <Button name = "." onClick = {props.getNumber} shadow = {props.numbersShadowColor} color = {props.numbersColor} background = {props.numbersBackgroundColor}/>
            <Button name = "0" onClick = {props.getNumber} shadow = {props.numbersShadowColor} color = {props.numbersColor} background = {props.numbersBackgroundColor}/>
            <Button name = "/" onClick = {props.getNumber} shadow = {props.numbersShadowColor} color = {props.numbersColor} background = {props.numbersBackgroundColor}/>
            <Button name = "*" onClick = {props.getNumber} shadow = {props.numbersShadowColor} color = {props.numbersColor} background = {props.numbersBackgroundColor}/>
            <Default 
                name = "RESET"
                clicked = {props.reset} 
                backgroundColor = {props.resetBackgroundColor}
                shadowColor = {props.resetShadowColor}
                color = {props.resetColor}
            />
            <Default name = "="
                clicked = {props.equals} 
                backgroundColor = {props.equalsBackgroundColor}
                shadowColor = {props.equalsShadowColor}
                color = {props.equalsColor}
             />
        </div>
    )
}